import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationConfigService } from 'src/app/core/config/application-config.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { AuditLogFilter } from './audit-log.model';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  private resourceUrl: string;
  private reportUrl: string;

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private applicationConfigService: ApplicationConfigService
  ) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('corporate/admin');
    this.reportUrl = this.applicationConfigService.getEndpointFor('report');
  }

  getAuditLogList(query: AuditLogFilter) {
    const queryStr = this.commonService.toQueryString(query);
    return this.http.get(`${this.resourceUrl}/audit-log/search?${queryStr}`);
  }

  getFeatureDropDown() {
    return this.http.get(`${this.resourceUrl}/admin-feature/all`);
  }

  getAllBranch() {
    return this.http.get(`${this.resourceUrl}/branch/list`);
  }

  getAllUsers() {
    return this.http.get(`${this.resourceUrl}/user/audit-log/all`);
  }

  download(query: any) {
    const queryStr = this.commonService.toQueryString(query);
    return this.http.get(`${this.resourceUrl}/audit-log/download?${queryStr}`, {
      responseType: 'blob',
    });
  }
}
